/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { DevBugIcon16Light } from './DevBugIcon16Light';
import { DevBugIcon16Regular } from './DevBugIcon16Regular';
import { DevBugIcon16Solid } from './DevBugIcon16Solid';
import { DevBugIcon20Light } from './DevBugIcon20Light';
import { DevBugIcon20Regular } from './DevBugIcon20Regular';
import { DevBugIcon20Solid } from './DevBugIcon20Solid';
import { DevBugIcon24Regular } from './DevBugIcon24Regular';
import { DevBugIcon24Solid } from './DevBugIcon24Solid';
import { DevBugIcon32Regular } from './DevBugIcon32Regular';
import { DevBugIcon64Regular } from './DevBugIcon64Regular';
var sizes = {
    16: {
        light: DevBugIcon16Light,
        regular: DevBugIcon16Regular,
        solid: DevBugIcon16Solid,
    },
    20: {
        light: DevBugIcon20Light,
        regular: DevBugIcon20Regular,
        solid: DevBugIcon20Solid,
    },
    24: {
        regular: DevBugIcon24Regular,
        solid: DevBugIcon24Solid,
    },
    32: {
        regular: DevBugIcon32Regular,
    },
    64: {
        regular: DevBugIcon64Regular,
    },
};
export var DevBugIcon = forwardRef('DevBugIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
